// Packages
import { useState } from 'react';

// Components
import TestEquipmentList from 'modules/TestEquipment/components/List';
import TestEquipmentCreateScreen from '../Create';
import AddIcon from 'components/BTDUI/icons/BTDFAB';
import TestEquipmentLayout from 'modules/TestEquipment/layouts';
import BTDPagination from 'components/BTDUI/BTDPagination';
import BTDProgress from 'components/BTDUI/BTDProgress';

// Other
import useApi from 'hooks/useApi';
import './styles.css'

const TestEquipmentScreen = () => {

    const [page, setPage] = useState(1);

    const { data: testEquipment, isLoading, meta, onChange } = useApi('/testequipment?page=' + page + '&per_page=100');
    
    const [formActive, setFormActive] = useState(false);


    return(
        <TestEquipmentLayout title='Test Equipment'>

            <div className='TestEquipmentListScreen__filters'>

            </div>

            {meta && meta.length !== 0 &&
                <p className='TestEquipmentListScreen__text opacity'>Displaying {meta.from.toLocaleString()} to {meta.to.toLocaleString()} of {meta.total.toLocaleString()} test equipment</p>
            }

            { isLoading ? 
                <>
                <div style={{ 
                    alignItems: 'center',
                    display: 'flex',
                    height: '40vh',
                    justifyContent: 'center',
                    width: '100%', 
                    }}
                >
                    <BTDProgress height={50} type='circular' width={50} />
                </div>
            </>
            :
                <TestEquipmentList 
                    isLoading={isLoading}  
                    items={testEquipment} 
                    onChange={() => {onChange()}}
                />
                }

            {meta && meta.total > meta.per_page &&
                <BTDPagination
                    currentPage={meta.current_page} 
                    totalPages={meta.last_page}
                    onChange={(value) => {
                        setPage(value);
                        onChange();
                    }}
                    style={{margin: '30px auto', width: 'max-content'}}
                />
            }	

            <AddIcon colour='#40506B' onClick={() => {
                setFormActive(true);
            }} />

            {formActive &&
                <TestEquipmentCreateScreen
                    onClose={() => {
                        setFormActive(false);
                    }} 
                    onSubmit={() => {
                        onChange();
                        setFormActive(false);
                    }} 
                />
            }

        </TestEquipmentLayout>
    )

}

export default TestEquipmentScreen;